import * as Process from './process'
import * as Node from './node'
import * as Sample from './sample'

import { createStructuredSelector } from 'reselect'

export const getCurrent = ({ current }) => current

export const getProcess = (state) => {
  const { processID } = getCurrent(state)
  if (!processID) return
  return Process.get(state, processID)
}

export const getSample = (state) => {
  const { processID } = getCurrent(state)
  if (!processID) return
  return Sample.getForProcess(state, processID)
}

export const getNode = (state) => {
  const { processID, nodeID } = getCurrent(state)
  if (!processID || !nodeID) return
  return Node.get(state, processID, nodeID)
}

export const get = createStructuredSelector({
  process: getProcess,
  sample: getSample,
  node: getNode
})



// WEBPACK FOOTER //
// ../webmango-core/selectors/current.js